import ComparisonStats from "../components/Home/comparision";
import CTA from "../components/Home/cta";
import Hero from "../components/Home/hero-section";
import PopularLoans from "../components/Home/popular-loans";
import FinancialCalculators from "../components/Home/financial-calculators";
import TrustedPartners from "../components/Home/trusted-partners";
import LeadProcess from "../components/Home/lead-process";
import Process from "../components/Home/process";
import RoleSection from "../components/Home/role";
import InfrastructureMap from "../components/Home/infrastructure-map";
import FinalCTA from "../components/How-it-work/final-cta";

function Home() {
  return (
    <main>
      <div className="pt-20">
        <Hero />
        <PopularLoans /> 
        <CTA />
        <FinancialCalculators />
        <TrustedPartners />
        <LeadProcess />
        <Process />
        <ComparisonStats />
        <InfrastructureMap />
        <RoleSection />
        <FinalCTA
          title={
            <>
              A good lead can't wait. Neither should
              <br className="hidden sm:block" />
              the DSA who found it.
            </>
          }
        />
      </div>
    </main>
  );
}

export default Home;
